import { useTranslate } from "@similarweb/i18n-provider";
import { Flex } from "@similarweb/ui-components/foundations";

import ManagementCardFilterTag from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardFilterTag";
import { WEBHOOK_FIND_NEW_COMPANIES_PRICE } from "app/pages/sales-intelligence/modules/manage-integrations/constants/webhooks";

import APIsCardsList from "../components/APIsCardsList/APIsCardsList";
import CardsWrapper from "../components/CardsWrapper/CardsWrapper";
import { FindNewCompaniesCard } from "../components/integration-cards/FindNewCompaniesCard/FindNewCompaniesCard";
import { SignalsWebhookCard } from "../components/integration-cards/SignalsWebhookCard/SignalsWebhookCard";
import {
    MANAGE_INTEGRATIONS_CARD_ENGAGEMENT_TAG,
    MANAGE_INTEGRATIONS_CARD_PROSPECTING_TAG,
    MANAGE_INTEGRATIONS_WEBHOOKS_TITLE,
} from "../constants/translations";
import useFindNewCompaniesData from "../hooks/useFindNewCompaniesData";
import useSignalsApiData from "../hooks/useSignalsApiData";

const APIsWebhooksContainer = (): React.ReactElement => {
    const { translate } = useTranslate();

    const signalsApiProps = useSignalsApiData();
    const findNewCompaniesProps = useFindNewCompaniesData();

    return (
        <Flex
            flexDirection="column"
            gap="24px"
        >
            <APIsCardsList />

            <CardsWrapper title={translate(MANAGE_INTEGRATIONS_WEBHOOKS_TITLE)}>
                <SignalsWebhookCard {...signalsApiProps}>
                    <ManagementCardFilterTag iconName="spend">
                        {translate(MANAGE_INTEGRATIONS_CARD_ENGAGEMENT_TAG)}
                    </ManagementCardFilterTag>
                </SignalsWebhookCard>
                <FindNewCompaniesCard {...findNewCompaniesProps}>
                    <ManagementCardFilterTag iconName="spend">
                        {WEBHOOK_FIND_NEW_COMPANIES_PRICE}
                    </ManagementCardFilterTag>
                    <ManagementCardFilterTag iconName="spend">
                        {translate(MANAGE_INTEGRATIONS_CARD_PROSPECTING_TAG)}
                    </ManagementCardFilterTag>
                </FindNewCompaniesCard>
            </CardsWrapper>
        </Flex>
    );
};

export default APIsWebhooksContainer;
